export const scrollToElementById = (id: string): void => {
    const element = document.getElementById(id);
    const headerOffset = 54;
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
    });
};

export const scrollToTop = (): void => {
    window.scrollTo({
        top: 0,
        behavior: 'auto',
    });
};
